export default __webpack_public_path__ + "static/media/emna.52d69406.jpg";